import { combineReducers } from 'redux';

import dataNovaMap from './data-nova-map';
import { entities } from './entities';
import errors from './errors';
import filterPush from './filter-push';
import { locale } from './i18n';
import loaded from './loaded';
import loaders from './loaders';
import main from './main';
import paginations from './paginations';
import rgpd from './rgpd';
import search from './search';

const rootReducer = combineReducers({
  paginations,
  entities,
  locale,
  loaders,
  errors,
  search,
  loaded,
  rgpd,
  main,
  dataNovaMap,
  filterPush,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
